<template>
  <a-modal
    :visible="visible"
    centered
    @cancel="handleCancel"
    width="50%"
    :title="title"
    :footer="false"
  >
    <a-divider v-if="showDividers">{{ $t("conseilClass.options") }}</a-divider>
    <a-row :gutter="[8, 32]">
      <a-form
        :label-col="{ span: 16 }"
        :wrapper-col="{ span: 16, offset: 8 }"
        :form="form"
      >
        <a-col v-if="config.allow" :span="spanNb">
          <a-form-item :label="$t('conseilClass.allow')">
            <div class="d-flex align-items-center">
              <a-switch
                v-decorator="[
                  'allow',
                  {
                    initialValue: defaultData.allow,
                    valuePropName: 'checked',
                  },
                ]"
              />
            </div>
          </a-form-item>
        </a-col>
        <a-col v-if="config.auto" :span="spanNb">
          <a-form-item :label="$t('conseilClass.auto')">
            <div class="d-flex align-items-center">
              <a-switch
                v-decorator="[
                  'auto',
                  {
                    initialValue: defaultData.auto,
                    valuePropName: 'checked',
                  },
                ]"
              />
            </div>
          </a-form-item>
        </a-col>
        <a-col v-if="config.useSchoolCode" :span="spanNb">
          <a-form-item :label="$t('conseilClass.useSchoolCode')">
            <div class="d-flex align-items-center">
              <a-switch
                v-decorator="[
                  'useSchoolCode',
                  {
                    initialValue: defaultData.useSchoolCode,
                    valuePropName: 'checked',
                  },
                ]"
              />
            </div>
          </a-form-item>
        </a-col>
        <a-col v-if="config.repeatEachPage" :span="spanNb">
          <a-form-item :label="$t('conseilClass.repeatEachPage')">
            <div class="d-flex align-items-center">
              <a-switch
                v-decorator="[
                  'repeatEachPage',
                  {
                    initialValue: defaultData.repeatEachPage,
                    valuePropName: 'checked',
                  },
                ]"
              />
            </div>
          </a-form-item>
        </a-col>
        <a-col v-if="config.rect" :span="spanNb">
          <a-form-item :label="$t('conseilClass.rect')">
            <div class="d-flex align-items-center">
              <a-switch
                v-decorator="[
                  'rect',
                  {
                    initialValue: defaultData.rect,
                    valuePropName: 'checked',
                  },
                ]"
              />
            </div>
          </a-form-item>
        </a-col>
      </a-form>
    </a-row>
    <a-divider v-if="config.textEdit">{{
      $t("bulletinBuilder.titre")
    }}</a-divider>
    <a-row :gutter="[8, 32]" v-if="config.textEdit">
      <a-form
        :form="headerSettingForm"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-col :span="12">
          <a-form-item :label="$t('bulletinBuilder.font') + ' :'">
            <a-select
              placeholder="Select a font"
              style="width: 100%"
              v-decorator="[
                'font',
                {
                  initialValue: activeSideFontConfig.font,
                },
              ]"
            >
              <template>
                <a-select-opt-group
                  v-for="(group, index) in fontGroups"
                  :label="group.label"
                  :key="index"
                >
                  <a-select-option
                    v-for="font in group.options"
                    :key="font.value"
                    :value="font.value"
                  >
                    {{ font.label }}
                  </a-select-option>
                </a-select-opt-group>
              </template>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item :label="$t('bulletinBuilder.taille') + ' :'">
            <a-input-number
              :min="6"
              :max="24"
              v-decorator="[
                'size',
                {
                  initialValue: activeSideFontConfig.size,
                },
              ]"
            />
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item :label="$t('bulletinBuilder.couleur') + ' :'">
            <a-input
              type="color"
              v-decorator="[
                'color',
                {
                  initialValue: activeSideFontConfig.color,
                },
              ]"
            />
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item :label="$t('bulletinBuilder.titre') + ' :'">
            <a-input
              v-decorator="[
                'text',
                {
                  initialValue: activeSideFontConfig.text,
                },
              ]"
            />
          </a-form-item>
        </a-col>
      </a-form>
    </a-row>
    <a-divider v-if="config.richText">{{
      $t("bulletinBuilder.richText")
    }}</a-divider>
    <a-row v-if="config.richText">
      <a-col :span="24">
        <div class="d-flex align-items-center">
          <quill-editor
            :value="defaultData.richText"
            :options="editorOptions"
            @change="quillChange"
          />
        </div>
      </a-col>
    </a-row>
    <a-row v-if="config.richText">
      <a-col :span="24">
        <div v-html="quillData || '<div></div>'"></div>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="12" :offset="12">
        <a-button type="primary" class="w-100" @click="save">
          <a-icon type="save" />{{ $t("all.apply") }}
        </a-button>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script>
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import Quill from "quill";
import MagicUrl from "quill-magic-url";
import "quill/dist/quill.snow.css";
Quill.register("modules/magicUrl", MagicUrl);
function encodeTextOptions(options) {
  console.info("encode: ", options);
  return {
    font:
      options.font && options.fontStyle
        ? `${options.font}-${options.fontStyle}`
        : "Amiri-Bold",
    color: options.color || "#000000",
    size: options.fontSize || 14,
    text: options.text || "",
  };
}
function decodeTextOptions(options) {
  console.info("decode: ", options);
  let returns = {
    color: options.color || "#000000",
    fontSize: options.size || 14,
    text: options.text || "",
  };
  if (options.font && typeof options.font == "string") {
    const [font, fontStyle] = options.font.split("-");
    return { ...returns, font, fontStyle };
  } else return { ...returns, font: "Amiri", fontStyle: "Bold" };
}
export default {
  name: "ConfigModal",
  components: {
    quillEditor,
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
    defaultData: {
      type: Object,
      required: true,
    },
    visible: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    spanNb() {
      const truth = [
        this.config.allow,
        this.config.auto,
        this.config.repeatEachPage,
        this.config.rect,
        this.config.useSchoolCode,
      ].filter(Boolean).length;
      if (truth <= 2) return 12;
      if (truth == 3) return 8;
      else return 6;
    },
    showDividers() {
      return (
        [
          this.config.allow,
          this.config.auto,
          this.config.repeatEachPage,
          this.config.rect,
          this.config.useSchoolCode,
        ].filter(Boolean).length > 0 && this.config.textEdit
      );
    },
    activeSideFontConfig() {
      return this.defaultData.text
        ? encodeTextOptions(this.defaultData.text)
        : {
            font: "Amiri-Bold",
            color: "#000000",
            size: 14,
            text: "",
          };
    },
  },
  watch: {
    defaultData: function (newVal) {
      console.info({ newVal });
      this.form.setFieldsValue(newVal);
      if (this.config.textEdit && newVal.text)
        this.headerSettingForm.setFieldsValues(newVal.text);
      if (this.config.richText) this.quillData = this.defaultData.richText;
    },
  },
  created() {
    if (this.config.richText) this.quillData = this.defaultData.richText;
  },
  data() {
    return {
      form: this.$form.createForm(this),
      headerSettingForm: this.$form.createForm(this),
      fontGroups: [
        {
          label: "Arabe et français",
          options: [
            { value: "Amiri-normal", label: "Amiri (Normal)" },
            { value: "Amiri-Bold", label: "Amiri (Bold)" },
            {
              value: "NotoNaskhArabic-normal",
              label: "Noto Naskh Arabic (Normal)",
            },
          ],
        },
        {
          label: "Arabe seulement",
          options: [
            {
              value: "Noto Sans Arabic-Bold",
              label: "Noto Sans Arabic (Bold)",
            },
            {
              value: "Al Jazeera Arabic-Bold",
              label: "Al Jazeera Arabic (Bold)",
            },
            {
              value: "PT Bold Heading-Bold",
              label: "PT Bold Heading (Bold)",
            },
          ],
        },
      ],
      editorOptions: {
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            ["link"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }],

            [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],

            [{ color: [] }, { background: [] }],
            [{ font: [] }],
            [{ align: [] }],

            ["clean"],
          ],
          magicUrl: true,
        },
      },
      quillData: null,
    };
  },
  methods: {
    quillChange(props) {
      this.quillData = props.html;
    },
    save() {
      let returns;
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) returns = { ...values };
      });
      if (this.config.textEdit)
        this.headerSettingForm.validateFieldsAndScroll((err, values) => {
          if (!err)
            returns = { ...returns, ...decodeTextOptions({ ...values }) };
        });
      if (this.config.richText)
        returns.richText = this.quillData || defaultData.richText;
      this.$emit("save", returns);
    },
    handleCancel() {
      this.$emit("cancel");
    },
  },
};
</script>
